import React, { Fragment, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'

import { successMessages } from '@/constants/feedbackMessages'
import {
	BreadCrumb,
	Button,
	Input,
	Loader,
	ModalBase,
	Paragraph,
	SelectMove,
	Small,
	Title,
} from '@components/atoms'
import SearchInput from '@components/atoms/SearchInput'
import {
	Bookmark20Regular,
	Folder20Filled,
	MoreVertical16Regular,
} from '@fluentui/react-icons'
import { Menu, Transition } from '@headlessui/react'
import { handleShareLink } from '@helpers'
import { yupResolver } from '@hookform/resolvers/yup'
import {
	CreateFilterInFolderRequest,
	FilterClientResponseType,
} from '@models/filter.model'
import { EditNotebookRequest } from '@models/notebook.model'
import { filterInFolderClientSchema } from '@schemas/filters/filters.schema'
import { newNotebookSchema } from '@schemas/questions/questions.schema'
import { filterAPI } from '@services/FiltersAPI'
import { notificationCreators } from '@store/ducks/notification'
import { useAppDispatch } from '@store/hooks'
import moment from 'moment'

import { NotebooksStyles } from '../../Notebooks/style'

const {
	container,
	title,
	folderCard,
	iconFolder,
	iconDesc,
	buttonDropdown,
	dropdownItems,
	dropdownItem,
	containerNotebooks,
} = NotebooksStyles

export const FolderShowFilters = () => {
	const [openModalEditlNotebook, setOpenModalEditlNotebook] = useState(false)
	const [openModalDeleteFilterClient, setOpenModalDeleteFilterClient] =
		useState(false)
	const [openModalFilterInFolder, setOpenModalFilterInFolder] = useState(false)
	const [deleteFilterClient, setDeleteFilterClient] = useState('')
	const [allFiltersClient, setAllFiltersClient] =
		useState<Array<FilterClientResponseType>>()
	const [search, setSearch] = useState<string>('')

	const dispatch = useAppDispatch()

	const {
		register: registerEditFilter,
		reset: resetEditFilter,
		setValue: setValueEditFilter,
		handleSubmit: handleSubmitEditFilter,
		formState: { errors: errorsEditNotebook },
	} = useForm<EditNotebookRequest>({
		resolver: yupResolver(newNotebookSchema),
	})

	const {
		reset: resetFilterInFolder,
		setValue: setValueFilterInFolder,
		handleSubmit: handleSubmitFilterInFolder,
		watch: watchFilterInFolder,
	} = useForm<CreateFilterInFolderRequest>({
		mode: 'onBlur',
		resolver: yupResolver(filterInFolderClientSchema),
	})

	const filterInFolderID = watchFilterInFolder('folderId')

	const navigation = useNavigate()

	const [getFolderShowFilters, { data, isSuccess, isLoading }] =
		filterAPI.useGetFolderFilterClientShowMutation()
	const [getAllClientFolder, { data: dataAllFolder }] =
		filterAPI.useGetAllFolderClientMutation()
	const [
		getOneClientFilter,
		{ data: dataOneClientFilter, isSuccess: isSuccessOneClientFilter },
	] = filterAPI.useGetOneFilterClientMutation()

	const [editFilter, { isSuccess: isSuccessEditFilter }] =
		filterAPI.usePutFilterClientMutation()
	const [deleteFilterClientAPI, { isSuccess: isSuccessDeleteFilter }] =
		filterAPI.useDeleteFilterClientMutation()

	const [postFilterInFolder, { isSuccess: isSuccessFilterInFolder }] =
		filterAPI.usePostFilterInFolderMutation()

	const { id: idFolder } = useParams()

	const filteredAllFilters =
		allFiltersClient &&
		allFiltersClient.filter((option) =>
			option.name.toLowerCase().includes(search.toLowerCase())
		)

	const onSubmitEditBook = handleSubmitEditFilter((payload) => {
		editFilter(payload)
	})

	const onSubmitFilterInFolder = handleSubmitFilterInFolder((payload) => {
		postFilterInFolder(payload)
	})

	const handleDeleteFilterClient = () => {
		if (deleteFilterClient) {
			deleteFilterClientAPI(deleteFilterClient)
		}
	}

	useEffect(() => {
		getFolderShowFilters(idFolder || '')
		getAllClientFolder()
	}, [getFolderShowFilters, getAllClientFolder, idFolder])

	useEffect(() => {
		if (isSuccess && data) {
			setAllFiltersClient(data.clientFilters)
		}
	}, [isSuccess, data])

	useEffect(() => {
		if (isSuccessEditFilter) {
			getFolderShowFilters(idFolder || '')
			resetEditFilter()
			setOpenModalEditlNotebook(false)
			dispatch(notificationCreators.show(successMessages.editedFilter))
		}
	}, [
		dispatch,
		getFolderShowFilters,
		idFolder,
		isSuccessEditFilter,
		resetEditFilter,
	])

	useEffect(() => {
		if (isSuccessDeleteFilter) {
			getFolderShowFilters(idFolder || '')
			setOpenModalDeleteFilterClient(false)
			setDeleteFilterClient('')
			dispatch(notificationCreators.show(successMessages.deletedFilter))
		}
	}, [dispatch, getFolderShowFilters, idFolder, isSuccessDeleteFilter])

	useEffect(() => {
		if (isSuccessFilterInFolder) {
			getAllClientFolder()
			setOpenModalFilterInFolder(false)
			resetFilterInFolder()
			dispatch(notificationCreators.show(successMessages.moveFilter))
		}
	}, [
		dispatch,
		getAllClientFolder,
		isSuccessFilterInFolder,
		resetFilterInFolder,
	])

	useEffect(() => {
		if (isSuccessOneClientFilter && dataOneClientFilter) {
			navigation(
				`/vade-mecum-de-questoes?filter=${JSON.stringify(
					dataOneClientFilter.filters
				)}`
			)
		}
	}, [isSuccessOneClientFilter, dataOneClientFilter, navigation])

	return (
		<div className={container()}>
			<div>
				<BreadCrumb
					buttonReturn
					locations={
						data?.name
							? [
									{ name: 'Filtros salvos', link: '/filtros-salvos' },
									{ name: `Pasta ${data?.name}`, link: '' },
							  ]
							: []
					}
				/>

				<div className={title()}>
					<Title variant='h1' color='$neutral160'>
						{data?.name || ''}
					</Title>
					<div>
						<SearchInput
							placeholder='Busque pelo nome'
							maxLength={30}
							onChange={(e) => setSearch(e.target.value)}
							value={search}
							css={{ maxWidth: '100%', '@md': { maxWidth: '287px' } }}
						/>
					</div>
				</div>
			</div>

			<Title variant='h2' color='$neutral110'>
				Filtros
			</Title>

			<div className={containerNotebooks()}>
				{isLoading ? (
					<Loader />
				) : (
					filteredAllFilters?.map(({ name, id, createdAt }, key) => {
						return (
							<div className={folderCard()} key={key}>
								<button type='button' className={iconDesc()}>
									<div className={iconFolder()}>
										<Bookmark20Regular />
									</div>

									<div
										onClick={() => {
											getOneClientFilter(id)
										}}
									>
										<Paragraph
											paragraphType='p1'
											css={{ color: '$neutral100' }}
										>
											{name}
										</Paragraph>

										<Small smallType='small1' css={{ color: '$neutral90' }}>
											Criado em {moment(createdAt).format('MM/YYYY')}
										</Small>
									</div>
								</button>

								<Menu as='div'>
									<div className={buttonDropdown()}>
										<Menu.Button>
											<MoreVertical16Regular />
										</Menu.Button>
									</div>
									<Transition
										as={Fragment}
										enter='transition ease-out duration-100'
										enterFrom='transform opacity-0 scale-95'
										enterTo='transform opacity-100 scale-100'
										leave='transition ease-in duration-75'
										leaveFrom='transform opacity-100 scale-100'
										leaveTo='transform opacity-0 scale-95'
									>
										<Menu.Items className={dropdownItems()}>
											<Menu.Item>
												<button
													type='button'
													className={dropdownItem()}
													onClick={() => {
														handleShareLink({ type: 'filter', id })
														dispatch(
															notificationCreators.show(
																successMessages.copyLink
															)
														)
													}}
												>
													Compartilhar
												</button>
											</Menu.Item>
											<Menu.Item>
												<button
													type='button'
													className={dropdownItem()}
													onClick={() => {
														setValueFilterInFolder('clientFilterId', id)
														setOpenModalFilterInFolder(true)
													}}
												>
													Mover
												</button>
											</Menu.Item>
											<Menu.Item>
												<button
													type='button'
													className={dropdownItem()}
													onClick={() => {
														setValueEditFilter('name', name)
														setValueEditFilter('id', String(id))
														setOpenModalEditlNotebook(!openModalEditlNotebook)
													}}
												>
													Renomear
												</button>
											</Menu.Item>
											<Menu.Item>
												<button
													type='button'
													className={dropdownItem()}
													onClick={() => {
														setOpenModalDeleteFilterClient(
															!openModalDeleteFilterClient
														)
														setDeleteFilterClient(String(id))
													}}
												>
													Excluir
												</button>
											</Menu.Item>
										</Menu.Items>
									</Transition>
								</Menu>
							</div>
						)
					})
				)}
			</div>

			<ModalBase
				title='Renomear filtro'
				open={openModalEditlNotebook}
				onOpenChange={setOpenModalEditlNotebook}
			>
				<form onSubmit={onSubmitEditBook} style={{ width: '100%' }}>
					<Input
						placeholder='Digite o nome do filtro...'
						error={errorsEditNotebook.name?.message}
						{...registerEditFilter('name')}
						css={{ marginBottom: '34px', marginTop: '58px' }}
					/>
					<div style={{ display: 'flex', gap: '26px', marginTop: '34px' }}>
						<Button>Salvar</Button>
						<Button
							outlined
							onClick={() => {
								setOpenModalEditlNotebook(false)
								resetEditFilter()
							}}
						>
							Cancelar
						</Button>
					</div>
				</form>
			</ModalBase>

			<ModalBase
				title='Excluir Filtro'
				open={openModalDeleteFilterClient}
				onOpenChange={setOpenModalDeleteFilterClient}
			>
				<div>
					<Title variant='h4' color='$neutral160'>
						Deseja apagar todo este filtro?
					</Title>
					<div style={{ display: 'flex', gap: '26px', marginTop: '34px' }}>
						<Button onClick={handleDeleteFilterClient}>Apagar</Button>
						<Button
							outlined
							onClick={() => {
								setOpenModalDeleteFilterClient(!openModalDeleteFilterClient)
							}}
						>
							Cancelar
						</Button>
					</div>
				</div>
			</ModalBase>

			<ModalBase
				title='Mover Filtro'
				open={openModalFilterInFolder}
				onOpenChange={(e) => {
					resetFilterInFolder()
					setOpenModalFilterInFolder(e)
				}}
			>
				<div
					style={{ display: 'flex', flexDirection: 'column', width: '100%' }}
				>
					<form
						onSubmit={onSubmitFilterInFolder}
						style={{
							marginTop: '34px',
							display: 'flex',
							flexDirection: 'column',
						}}
					>
						<SelectMove
							options={
								(dataAllFolder &&
									dataAllFolder.map((folder) => {
										return { value: folder.id, option: folder.name }
									})) ||
								[]
							}
							onChange={(e) => {
								setValueFilterInFolder('folderId', Number(e.value))
							}}
						/>

						<div
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								gap: '26px',
								marginTop: '17px',
								paddingLeft: '16px',
							}}
						>
							<Folder20Filled />
							{filterInFolderID ? (
								<Button css={{ maxWidth: '164px' }}>Mover</Button>
							) : (
								<Button disabled css={{ maxWidth: '164px' }}>
									Mover para cá
								</Button>
							)}
						</div>
					</form>
				</div>
			</ModalBase>
		</div>
	)
}
